import { Button, Card, CardBody, Id, SplitButton, useOpen } from "@dgs/core";
import { FC, useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ApplicationType } from "../../shared/types";
import { DeepApplicationConfiguration } from "../../shared/types/application";
import { CreateApplicationDrawer } from "./applications/create/CreateApplicationDrawer";

interface Props {
	eventId: Id;
	applicationType: ApplicationType;
}

const StyledCard = styled(Card)`
	min-height: 300px;
	margin-bottom: 0;
`;

const StyledCardBody = styled(CardBody)`
	display: flex;
	height: 100%;
	justify-content: center;
	align-items: center;
`;

export const CreateApplicationCard: FC<Props> = ({ eventId, applicationType }) => {
	const { t } = useTranslation();
	const { open, handleOpen, handleClose } = useOpen();
	const [config, setConfig] = useState<DeepApplicationConfiguration | null>(null);

	const onClose = useCallback(() => {
		handleClose();
		setConfig(null);
	}, [handleClose]);

	const buttonText = useMemo(() => {
		switch (applicationType) {
			case ApplicationType.KRONOS:
				return t("Create KRONOS");
			case ApplicationType.PARTICIPANT_MANAGEMENT:
				return t("Create Participant Management");
		}

		return null;
	}, [applicationType, t]);

	return (
		<>
			<StyledCard>
				<StyledCardBody>
					{applicationType === ApplicationType.DEEP ? (
						<SplitButton
							color="primary"
							options={[
								{
									title: t("Create DEEP"),
									onClick: () => {
										setConfig({ enableApp: false, enableFrontend: true });
										handleOpen();
									},
								},
								{
									title: t("Create APP"),
									onClick: () => {
										setConfig({ enableApp: true, enableFrontend: false });
										handleOpen();
									},
								},
								{
									title: t("Create DEEP & APP"),
									onClick: () => {
										setConfig({ enableApp: true, enableFrontend: true });
										handleOpen();
									},
								},
							]}
						/>
					) : (
						<Button
							onClick={() => {
								setConfig(null);
								handleOpen();
							}}
							color="primary"
						>
							{buttonText}
						</Button>
					)}
				</StyledCardBody>
			</StyledCard>
			<CreateApplicationDrawer
				eventId={eventId}
				open={open}
				onClose={onClose}
				applicationType={applicationType}
				config={config}
			/>
		</>
	);
};
